import type { LocaleValue, SectionLocale } from '../types'

import { ADMIN_BASE_LOCALE } from './adminBase'
import { ADMIN_DEPARTMENTS_LOCALE } from './adminDepartments'
import { ALLOCATE_COINS_LOCALE } from './allocateCoins'
import { AUTH_LOCALE } from './auth'
import { BASE_LOCALE } from './base'
import { EVENTS_LOCALE } from './events'
import { FAQ_LOCALE } from './faq'
import { FEEDBACK_LOCALE } from './feedback'
import { HEADER_LOCALE } from './header'
import { HOME_LOCALE } from './home'
import { INFO_LOCALE } from './info'
import { LOCATION_LOCALE } from './location'
import { METRICS_LOCALE } from './metrics'
import { NAVIGATION_LOCALE } from './navigation'
import { NEWS_LOCALE } from './news'
import { PROFILES_LOCALE } from './profiles'
import { ROLES_CONTROL_LOCALE } from './rolesControl'
import { SHOP_LOCALE } from './shop'
import { SIGNOUT_POPUP_LOCALE } from './signoutPopup'
import { TRANSACTIONS_LOCALE } from './transactions'
import { UPDATE_PAGE_PROMPT_LOCALE } from './updatePagePrompt'

const LOCALES: SectionLocale = [
  ...BASE_LOCALE,
  ...HOME_LOCALE,
  ...HEADER_LOCALE,
  ...SIGNOUT_POPUP_LOCALE,
  ...FAQ_LOCALE,
  ...NEWS_LOCALE,
  ...EVENTS_LOCALE,
  ...SHOP_LOCALE,
  ...FEEDBACK_LOCALE,
  ...PROFILES_LOCALE,
  ...ROLES_CONTROL_LOCALE,
  ...AUTH_LOCALE,
  ...INFO_LOCALE,
  ...LOCATION_LOCALE,
  ...NAVIGATION_LOCALE,
  ...METRICS_LOCALE,
  ...ALLOCATE_COINS_LOCALE,
  ...ADMIN_BASE_LOCALE,
  ...ADMIN_DEPARTMENTS_LOCALE,
  ...UPDATE_PAGE_PROMPT_LOCALE,
  ...TRANSACTIONS_LOCALE,
]

const getMappedLocales = () => {
  const locales: { en: Record<string, LocaleValue>; ru: Record<string, LocaleValue> } = {
    ru: {},
    en: {},
  }
  LOCALES.forEach(([key, value]) => {
    locales.ru[key] = value.ru
    locales.en[key] = value.en
  })
  return locales
}
const messages = getMappedLocales()

export default messages
